module.exports = __webpack_public_path__ + "img/d- (15).6447f282.png";